<template lang="pug">
MModalButton(
  v-bind:button-classes="buttonClasses || ''"
  v-bind:container-classes="containerClasses || ''"
  v-bind:title="`Internal Advertiser Issue for ${advertiserName}`"
  modal-size="modal-lg"
  v-on:modal-show="onModalShow"
)
  span( slot="button-inner" )
    | {{ buttonText || 'Report Internal Advertiser Issue' }}
    i( class="fa fa-exclamation-triangle ml-2" v-if="internalAdvertiserIssue.id" )
  
  div( slot="body" )
    div( v-if="loading" )
      i( class="fa fa-spinner fa-spin" )
      |  Loading...
    
    div( v-else )
      div
        p
          strong Classic
        div( class="row" )
          div( class="col-6" )
            img(
              class="w-100"
              v-bind:src="`https://d30bc2nkwjetgt.cloudfront.net/${referenceAuditScreenshots[0].screenshotUrl}`"
              v-if="referenceAuditScreenshots && referenceAuditScreenshots[0]"
            )

          div( class="col-6" )
            img(
              class="w-100"
              v-bind:src="`https://d30bc2nkwjetgt.cloudfront.net/${referenceAuditScreenshots[1].screenshotUrl}`"
              v-if="referenceAuditScreenshots && referenceAuditScreenshots[1]"
            )
        
        p( class="mt-4" )
          strong Lite
        div( class="row" )
          div( class="col-6" )
            img(
              class="w-100"
              v-bind:src="`https://moonpull-serverless-results.s3.amazonaws.com/screenshots/${referenceAuditId}-alp.png`"
              alt="Not found"
            )

          div( class="col-6" )
            img(
              class="w-100"
              v-bind:src="`https://moonpull-serverless-results.s3.amazonaws.com/screenshots/${referenceAuditId}-post-consent.png`"
              alt="Not found"
            )

      hr

      MForm(
        v-on:submit="onSubmit"
        v-bind:submit-text="submitText"
      )
        MInput(
          name="issueType"
          type="select"
          label="Issue Type"
          v-bind:options="issueTypes"
          v-bind:value="internalAdvertiserIssue.issueType"
        )

        MInput(
          name="comment"
          type="textarea"
          label="Comment"
          v-bind:value="internalAdvertiserIssue.comment"
        )

        MInput(
          name="resolutionConclusion"
          type="textarea"
          label="Resolution Conclusion"
          v-bind:value="internalAdvertiserIssue.resolutionConclusion"
          v-on:change="onResolutionConclusionChange"
          v-if="internalAdvertiserIssue.id"
        )
      
      p( v-if="willResolve" class="text-right" )
        em Providing a Resolution Conclusion will resolve this issue.

</template>

<style lang="scss" scoped>
</style>

<script>
import Vue from 'vue'
import { ref, computed } from '@vue/composition-api'
import { api } from '@/api'
import { flashMessage } from '@/store'
export default Vue.extend({
  props: [
    'advertiserId',
    'advertiserName',
    'referenceAuditId',
    'referenceAuditScreenshots',
    'buttonClasses',
    'buttonText',
    'containerClasses',
  ],
  emits: ['upsert'],
  setup(props, { emit }) {

    const { advertiserId, referenceAuditId } = props

    const loading = ref(true)

    const willResolve = ref(false)

    const internalAdvertiserIssue = ref({
      advertiserId,
      referenceAuditId,
    })

    const issueTypes = ref([
      {
        value: null,
        label: 'Select an issue type',
        disabled: true,
      },
      {
        value: 'cmp_issue',
        label: 'CMP exists but not clicked',
      },
      {
        value: 'soft_block',
        label: 'Soft block (please explain)',
      },
      {
        value: 'hard_block',
        label: 'Hard block',
      },
      {
        value: 'cookie_status_mismatch',
        label: 'Cookie status mismatch with manual check',
      },
      {
        value: 'other',
        label: 'Any other issue (please explain)',
      },
    ])

    const submitText = computed(() => {
      if (willResolve.value) {
        return 'Resolve Issue'
      }
      else if (internalAdvertiserIssue.value.id) {
        return 'Update Issue'
      }
      return 'Create Issue'
    })

    async function onModalShow() {
      loading.value = true
      try {
        const res = await api('GET', `/internal-advertiser-issues/${advertiserId}`)
        if (res.ok) {
          const data = await res.json()
          internalAdvertiserIssue.value = data.internalAdvertiserIssue
        }
      } catch (e) {
        console.error(`Unexpected issue loading advertiser internal issue: ${e.message}`, e.stack)
      }
      loading.value = false
    }

    function onResolutionConclusionChange(e) {
      willResolve.value = e.target.value.length > 0
    }

    async function onSubmit(data) {
      try {
        const res = await api('POST', '/internal-advertiser-issues', {
          id: internalAdvertiserIssue.value.id,
          advertiserId,
          referenceAuditId,
          issueType: data.issueType,
          comment: data.comment,
          resolutionConclusion: data.resolutionConclusion,
          resolvedAt: (willResolve.value) ? new Date() : null,
        })
        if (res.ok) {
          flashMessage('success', 'Internal advertiser issue submitted')
          const upsertedIssue = await res.json()
          internalAdvertiserIssue.value = upsertedIssue.internalAdvertiserIssue

          if (internalAdvertiserIssue.value.resolvedAt) {
            internalAdvertiserIssue.value = {
              advertiserId,
              referenceAuditId,
            }
            willResolve.value = false
          }
          emit('upsert')
        } else {
          const { message } = await res.json()
          flashMessage('danger', `Internal advertiser issue not submitted: ${message}`)
        }
      } catch (e) {
        console.error(`Unexpected issue submitting internal advertiser issue: ${e.message}`, e.stack)
        flashMessage('danger', `Unexpected issue submitting internal advertiser issue: ${e.message}`)
      }
    }

    return {
      loading,
      onModalShow,
      issueTypes,
      submitText,
      onSubmit,
      internalAdvertiserIssue,
      onResolutionConclusionChange,
      willResolve,
    }
  },

})
</script>

